export interface PoolState {
  a: number;
  b: number;
  fo: number;
  gov: string;
  p: number;
  ra: number;
  rb: number;
  set: number;
  ma: number;
}

export interface PoolPair {
  aId: number;
  aName: string;
  aUnitName: string;
  aDecimals: number;
  bId: number;
  bName: string;
  bUnitName: string;
  bDecimals: number;
  poolId: number;
}

export enum SwapTransferState {
  Prepare,
  InProgress,
  Finished,
  Error,
}

export enum SwapState {
  Initial = 0,
  Loading = 1,
  NoPoolExist = 2,
  InsufficientBalance = 4,
  HighPriceImpact = 8,
  EnterSwapAmount = 16
}

export enum CurrentField {
  From = "FROM",
  To = "TO",
  None = "NONE"
}

export type TransferType = "FROM" | "TO" | "NONE";